<div class="layout-main-container">
  <!-- Regione del contenuto principale: è la destinazione del collegamento di
       salto e il punto di ripartenza per chi naviga per regioni (WCAG 1.3.1). -->
  <main id="contenuto-principale" class="layout-main" tabindex="-1">
    <ui-title-bar></ui-title-bar>
    <!-- Avviso di accesso non riuscito: sotto il titolo di pagina, sopra il
         contenuto, così è la prima cosa che si incontra dopo il rimbalzo. -->
    <app-auth-notice></app-auth-notice>
    <router-outlet></router-outlet>
  </main>
  <app-footer></app-footer>
</div>
